import React, { useEffect, useState } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { message } from 'antd';

const InitData = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  const states = [
    { name: 'Tamil Nadu' },
    { name: 'Kerala' },
    { name: 'Karnataka' },
    { name: 'Andhra Pradesh' },
    { name: 'Maharashtra' }
  ];

  const districts = {
    'Tamil Nadu': ['Mayiladurai', 'Coimbatore', 'Madurai', 'Salem', 'Tirunelveli'],
    'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam'],
    'Karnataka': ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum'],
    'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool'],
    'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Aurangabad']
  };

  const generateDistrictMembers = (state, district) => {
    const members = [];
    const parties = ['திமுக', 'அதிமுக', 'மநிக'];
    
    for (let i = 1; i <= 5; i++) {
      members.push({
        username: `Member ${i} of ${district}`,
        state: state,
        district: district,
        role: parties[i % 3], // Rotating through parties
        profileImage: `https://api.dicebear.com/7.x/avataaars/svg?seed=${district}${i}`,
        email: `member${i}@${district}.com`,
        votes: {
          question1: { yes: 0, no: 0 },
          question2: { yes: 0, no: 0 },
          question3: { yes: 0, no: 0 }
        },
        pollQuestions: [
          "Do you support the new infrastructure development plan?",
          "Should we increase the education budget?",
          "Are you in favor of the new environmental policies?"
        ],
        comments: []
      });
    }
    return members;
  };

  const checkIfDataExists = async () => {
    const statesSnapshot = await getDocs(collection(db, 'states'));
    return !statesSnapshot.empty;
  };

  // useEffect(() => {
  //   const initialize = async () => {
  //     const dataExists = await checkIfDataExists();
      
  //     if (!dataExists && !isInitialized) {
  //       try {
  //         // Add states
  //         const statesPromises = states.map(state => 
  //           addDoc(collection(db, 'states'), state)
  //         );
  //         await Promise.all(statesPromises);

  //         // Add districts and members
  //         const districtPromises = [];
  //         const memberPromises = [];

  //         Object.entries(districts).forEach(([state, districtList]) => {
  //           districtList.forEach(districtName => {
  //             districtPromises.push(
  //               addDoc(collection(db, 'districts'), {
  //                 name: districtName,
  //                 state: state
  //               })
  //             );

  //             const members = generateDistrictMembers(state, districtName);
  //             members.forEach(member => {
  //               memberPromises.push(
  //                 addDoc(collection(db, 'users'), member)
  //               );
  //             });
  //           });
  //         });

  //         await Promise.all(districtPromises);
  //         await Promise.all(memberPromises);

  //         message.success("Data initialized successfully!");
  //         setIsInitialized(true);
  //       } catch (error) {
  //         console.error("Error initializing data:", error);
  //         message.error("Error initializing data: " + error.message);
  //       }
  //     }
  //   };

  //   initialize();
  // }, []);

  return (
    <div>
      {isInitialized && <div>Data has been initialized!</div>}
    </div>
  );
};

export default InitData;
